import http from '@/plugins/http';
import { useAccountStore } from '@/stores/account';
import { useCompanyStore } from '@/stores/company';
import { useNotifierStore } from '@/stores/notifier';
import Company from '../../transformers/company';

const displaySepaBanner = (data) => {
  const message = 'home.unsigned_sepa.headband_text';
  if (data.paymentMethod !== 'offline_sepa' && data.payment_method !== 'offline_sepa') {
    return false;
  }

  if (data.mandate_inherited === true || data.is_mandate_inherited === true) {
    return false;
  }

  if (data.mandate !== null && data.mandate.mandate_id !== null) {
    return false;
  }

  if (!useAccountStore().canValidateOrder) {
    return false;
  }

  if (!useCompanyStore().noChildren) {
    return false;
  }

  useNotifierStore().open({
    message,
    type: 'aqua',
    close_name: 'sepa_banner',
    name: 'sepa_banner',
    onClickLink: async () => {
      http.post('/v3/mandate/generate', {}, {
        headers: { 'Content-Type': 'application/json' },
      })
        .then((response3) => {
          const redirectUrl = response3.data.authorisation_url;
          window.open(redirectUrl, '_blank');
        });
    },
  });
  return true;
};

export default (customerId) => new Promise((res, rej) => {
  http.get(`/v3/customers/${customerId}`)
    .then((response) => {
      let businessSector = response.data.business_sector;
      businessSector = businessSector.substring(4, businessSector.length);
      if (!displaySepaBanner(response.data)) {
        useNotifierStore().close({ close_name: 'sepa_banner', name: 'sepa_banner' });
      }

      http.get(businessSector)
        .then((response2) => {
          response.data.business_sector = response2.data.id;
          const result = Company.fetch(response.data);
          res(result);
        })
        .catch((error) => {
          rej(error);
        });
    })
    .catch((error) => {
      rej(error);
    });
});
